<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: String,
    duskAttribute: {
        type: String,
        default: '',
    },
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input ref="input" 
           class="border-0 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-lunar rounded" 
           :value="modelValue" 
           :dusk="duskAttribute"
           v-bind="$attrs"
           @input="$emit('update:modelValue', $event.target.value)">
</template>
